// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JFbaGC {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: var(--spacing-3);
  padding: var(--spacing-4);
}

.pauZxC {
  background: #fff0e5;
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
}

.cYoYs6 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  margin: 0;
}

.UFBAou {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 400px;
}

.hGIJW9 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
}

.Hr9FIr {
  margin-bottom: var(--spacing-1, 8px);
}

.A367KB {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: 600;
  font-size: var(--ibk-typography-fontSizeLg, 16px);
  line-height: 1.42;
  color: var(--surface-neutral-dark, #1f1f1f);
  margin: 0;
}

.aZMI5W {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1, 8px);
}

.yG2OJ4 {
  margin: calc(-1 * var(--spacing-3, 24px));
}

.pg7rQ2 {
  padding: var(--spacing-3, 24px);
  text-align: center;
}

.GeohJx {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2, 12px);
  margin-top: var(--spacing-3, 24px);
}

.GeohJx button {
  padding: var(--spacing-2, 12px) var(--spacing-3, 24px);
  border: 1px solid var(--surface-primary-medium, #d64000);
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--surface-primary-medium, #d64000);
  border-radius: var(--radius-s, 4px);
  cursor: pointer;
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: 600;
  font-size: var(--ibk-typography-fontSizeMd, 14px);
}

.GeohJx button:hover {
  background-color: var(--surface-primary-medium, #d64000);
  color: var(--on-surface-neutral-white, #ffffff);
}

.V7fNhJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-5, 40px) var(--spacing-2-5, 20px);
  min-height: 200px;
}

.gk5zn7 {
  display: flex;
  align-items: center;
  gap: var(--spacing-2, 16px);
}

.tfy_X5 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: 400;
  font-size: var(--ibk-typography-fontSizeMd, 14px);
  line-height: 1.8;
  color: var(--text-neutral-strong, #1f1f1f);
}

._gViQT {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: 600;
  font-size: var(--ibk-typography-fontSizeMd, 14px);
  line-height: 1.8;
  color: var(--text-neutral-strong, #1f1f1f);
}

.YD1do_ {
  position: absolute;
  right: 24px;
  top: 80px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}

@media (min-width: 768px) {
  .yG2OJ4 {
    flex-direction: row;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/RechargePaymentPage/components/PaymentContent/PaymentContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,iDAAiD;EACjD,iBAAiB;EACjB,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sDAAsD;EACtD,wDAAwD;EACxD,uDAAuD;EACvD,6CAA6C;EAC7C,mCAAmC;EACnC,eAAe;EACf,iEAAiE;EACjE,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;EAChC;AACF","sourcesContent":[".loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  gap: var(--spacing-3);\n  padding: var(--spacing-4);\n}\n\n.loadingIcon {\n  background: #fff0e5;\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n}\n\n.loadingText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.paymentForm {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 400px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n}\n\n.header {\n  margin-bottom: var(--spacing-1, 8px);\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: 600;\n  font-size: var(--ibk-typography-fontSizeLg, 16px);\n  line-height: 1.42;\n  color: var(--surface-neutral-dark, #1f1f1f);\n  margin: 0;\n}\n\n.paymentOptions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1, 8px);\n}\n\n.footer {\n  margin: calc(-1 * var(--spacing-3, 24px));\n}\n\n.pixFlow {\n  padding: var(--spacing-3, 24px);\n  text-align: center;\n}\n\n.pixActions {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2, 12px);\n  margin-top: var(--spacing-3, 24px);\n}\n\n.pixActions button {\n  padding: var(--spacing-2, 12px) var(--spacing-3, 24px);\n  border: 1px solid var(--surface-primary-medium, #d64000);\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--surface-primary-medium, #d64000);\n  border-radius: var(--radius-s, 4px);\n  cursor: pointer;\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: 600;\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n}\n\n.pixActions button:hover {\n  background-color: var(--surface-primary-medium, #d64000);\n  color: var(--on-surface-neutral-white, #ffffff);\n}\n\n.processingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-5, 40px) var(--spacing-2-5, 20px);\n  min-height: 200px;\n}\n\n.totalSection {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2, 16px);\n}\n\n.totalLabel {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: 400;\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n  line-height: 1.8;\n  color: var(--text-neutral-strong, #1f1f1f);\n}\n\n.totalValue {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: 600;\n  font-size: var(--ibk-typography-fontSizeMd, 14px);\n  line-height: 1.8;\n  color: var(--text-neutral-strong, #1f1f1f);\n}\n\n.alertMessage {\n  position: absolute;\n  right: 24px;\n  top: 80px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n\n@media (min-width: 768px) {\n  .footer {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `JFbaGC`,
	"loadingIcon": `pauZxC`,
	"loadingText": `cYoYs6`,
	"paymentForm": `UFBAou`,
	"content": `hGIJW9`,
	"header": `Hr9FIr`,
	"title": `A367KB`,
	"paymentOptions": `aZMI5W`,
	"footer": `yG2OJ4`,
	"pixFlow": `pg7rQ2`,
	"pixActions": `GeohJx`,
	"processingContainer": `V7fNhJ`,
	"totalSection": `gk5zn7`,
	"totalLabel": `tfy_X5`,
	"totalValue": `_gViQT`,
	"alertMessage": `YD1do_`
};
module.exports = ___CSS_LOADER_EXPORT___;
